'use strict';

export const baseURL = process.env.VUE_APP_baseURL;
export const buildEnv = process.env.VUE_APP_ENV;
export const googleAnalyticsId = process.env.VUE_APP_gaId;
export const projectName = 'pxplus_redirect';
export const PXPlusLink = process.env.VUE_APP_PXPlusLink;
export const PXPayLink = process.env.VUE_APP_PXPayLink;
export const IOSDownloadUrl = 'https://apps.apple.com/app/%E5%85%A8%E6%94%AF%E4%BB%98/id1605910655';
export const AOSDownloadUrl = 'https://play.google.com/store/apps/details?id=com.pxpayplus.app';
export const storagePrefix = 'pr';
export const domain = process.env.VUE_APP_domain;
export const bankAreaDomain = process.env.VUE_APP_bankAreaDomain;
export const SWPXPlusLink = process.env.VUE_APP_SWPXPlusLink;
export const SWPXPlusSDKLink = process.env.VUE_APP_SWPXPlusSDKLink;
export const externalRedirectList = {
  // key 名稱為專案名稱(拿掉 pxplus)加上頁面名稱，此 key 對應 produce_json 專案 pageName
  exploreLocation: 'pxplus_explore/web/location',
  exploreSearch: 'pxplus_explore/web/search',
  exploreTagSearch: 'pxplus_explore/web/tag_search/{id}',
  bankCooperateList: 'pxplus_bank_area/bank_cooperate_list',
  bankApplyCard: 'pxplus_bank_area/bank_apply_card/{bankCode}',
  brandsList: 'pxplus_brands/web/brand_list',
  brandsListPhysical: 'pxplus_brands/web/brand_list/physical', // 品牌實體商店
  brandsListOnline: 'pxplus_brands/web/brand_list/online', // 品牌網路商店
  brandsStoreList: 'pxplus_brands/web/store_list/{id}',
  brandsStoreDetail: 'pxplus_brands/web/store_detail/{id}',
  memberCardList: 'pxplus_member_card/web/card_list',
  memberCardDetail: 'pxplus_member_card/card_detail/{cardType}',
  bankAreaList: 'pxplus_bank_area/web/bank_area_list',
  paymentHomepage: 'pxplus_payment/web/homepage',
  cooperateStoreApply: 'pxplus_cooperate_store/web/apply',
  couponAllList: 'pxplus_coupon/web/coupon_list/all',
  couponResult: 'pxplus_coupon/web/coupon_result/{couponCode}'
};
